/**
 * Reviews Page — Rich Result Structured Data (SHOP-284)
 *
 * Fetches aggregate review data and individual reviews from the
 * Yotpo API and injects an Organization + AggregateRating + Review[]
 * JSON-LD schema into the placeholder <script> tag rendered by
 * microdata-schema.liquid.
 */
(function () {
  'use strict';

  var scriptTag = document.getElementById('reviews-structured-data');
  if (!scriptTag) return;

  var appKey = scriptTag.getAttribute('data-yotpo-app-key');
  if (!appKey) return;

  var API_BASE = 'https://api-cdn.yotpo.com/v1/widget/' + appKey;

  Promise.all([
    fetch(API_BASE + '/products/yotpo_site_reviews/reviews.json?per_page=10').then(function (r) { return r.json(); }),
  ])
    .then(function (results) {
      var bottomLine = results[0].response.bottomline;
      var reviewsData = results[0].response.reviews;

      if (!bottomLine) return;

      var ratingAverage = parseFloat(bottomLine.average_score);
      var ratingCount = parseInt(bottomLine.total_review, 10);

      var schema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        'name': scriptTag.getAttribute('data-shop-name'),
        'url': scriptTag.getAttribute('data-shop-url'),
        'aggregateRating': {
          '@type': 'AggregateRating',
          'ratingValue': ratingAverage,
          'bestRating': 5,
          'worstRating': 1
        }
      };

      if (!isNaN(ratingCount) && ratingCount > 0) {
        schema.aggregateRating.ratingCount = ratingCount;
      }

      // Build individual Review items from the first page of reviews
      var reviews = reviewsData || [];
      if (reviews.length > 0) {
        schema.review = reviews
          .filter(function (review) { return review.score && review.content; })
          .map(function (review) {
            var schemaReview = {
              '@type': 'Review',
              'reviewRating': {
                '@type': 'Rating',
                'ratingValue': review.score,
                'bestRating': 5,
                'worstRating': 1
              },
              'reviewBody': review.content,
              'name': review.title,
              'author': {
                '@type': 'Person',
                'name': review.user.display_name
              },
              'datePublished': review.created_at.substring(0, 10)
            };

            return schemaReview;
          });
      }

      scriptTag.textContent = JSON.stringify(schema, null, 2);
    })
    .catch(function (error) {
      console.warn('[Reviews Schema] Yotpo API fetch failed:', error.message);
    });
})();
